


import { buildNumberUpdate,userDataUpdate } from '../redux/user'

import React, { Component } from 'react'
//import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import apiService from '../services/ApiService'


class helpers extends Component {

    constructor() {
        super()
        this.state = {


            }
        }
    }

export function convertObjectToOptionComponents(firstName, objectData) {
    let components = []
    components.push(<option key="123@$" value="123@$">{firstName}</option>)

    for (let key in objectData) {
        if (objectData.hasOwnProperty(key)) {
            components.push(<option key={key} value={key}>{objectData[key]}</option>)
        }
    }

    return components
}

export function updateBuildNumber(data){

    apiService.getCityDetailList()
            .then(userData => {                
               this.props.dispatch(userDataUpdate(userData))
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
               window.location.reload()
            })
            .catch(err => {
                console.error("Error data: ", err)
            })     
    
}



export function validateEmployee(data){

    apiService.validateEmployee(data)
            .then(userData => {                
               return userData;
            })
            .catch(err => {
                return false
            })     
    
}

export function sortObjectAndCreateOptionComponents(firstOption, objectData) {
    let secondArray = []
    let sortedArray = []
    let newObject = []


   

    newObject.push(<option key="123@$" value="123@$">{firstOption}</option>)

    for (let key in objectData) {
        if (objectData.hasOwnProperty(key)) {
            secondArray.push(objectData[key])
        }
    }
    console.log(objectData)
    console.log(secondArray)
    sortedArray = secondArray.sort(function (a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase());
    })

    console.log(sortedArray)

    // for (let count = 0; count < sortedArray.length; count++) {
    //     let value = sortedArray[count]

    //     for (let key in objectData) {
    //         if (objectData.hasOwnProperty(key)) {
    //             if (objectData[key] + "" === value + "") {
    //                 newObject.push(<option key={key} value={key}>{value}</option>)
    //                 break
    //             }
    //         }
    //     }
    // }

    for (let key in objectData) {
        if (objectData.hasOwnProperty(key)) {
            newObject.push(<option key={key} value={key}>{objectData[key]}</option>)
        }
    }

    return newObject
}

export function sortObjectAndCreateOptionComponentsWithInitialValues(firstOption, secondOption, objectData) {
    let secondArray = []
    let sortedArray = []
    let newObject = []

    newObject.push(<option key="123@$" value="123@$">{firstOption}</option>)
    newObject.push(<option key={secondOption} value={secondOption}>{secondOption}</option>)

    for (let key in objectData) {
        if (objectData.hasOwnProperty(key)) {
            secondArray.push(objectData[key])
        }
    }

    sortedArray = secondArray.sort(function (a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase());
    })

    for (let count = 0; count < sortedArray.length; count++) {
        let value = sortedArray[count]

        for (let key in objectData) {
            if (objectData.hasOwnProperty(key)) {
                if (objectData[key] + "" === value + "") {
                    newObject.push(<option key={key} value={key}>{value}</option>)
                    break
                }
            }
        }
    }

    return newObject
}

//This is for input with tags option input value.
export function sortObjectAndCreateArrayOfObject(objectData) {
    let secondArray = []
    let sortedArray = []
    let newObject = []

    for (let key in objectData) {
        if (objectData.hasOwnProperty(key)) {
            secondArray.push(objectData[key])
        }
    }

    sortedArray = secondArray.sort(function (a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase());
    })

    for (let count = 0; count < sortedArray.length; count++) {
        let value = sortedArray[count]

        for (let key in objectData) {
            if (objectData.hasOwnProperty(key)) {
                if (objectData[key] + "" === value + "") {
                    newObject.push({ value: key, label: objectData[key] })
                    break
                }
            }
        }
    }

    return newObject
}

//This is for Multi-Select with tags option input value.
export function convertObjectToArrayOfObject(objectData) {
    let values = []

    for (let key in objectData) {
        if (objectData.hasOwnProperty(key)) {
            values.push({ value: key, label: objectData[key] })
        }
    }

    return values
}

export function isKeyExists(value, objectData) {
    if (value && objectData) {

        for (let key in objectData) {
            if (objectData.hasOwnProperty(key)) {
                if (key + "" === value + "") {
                    return true
                }
            }
        }

        return false
    } else {
        return false
    }
}

export function getReasonText(value, objectData) {
    if (value && objectData) {

        for (let key in objectData) {
            if (objectData.hasOwnProperty(key)) {
                if (key + "" === value + "") {
                    return objectData[key]
                }
            }
        }

        return "NA"
    } else {
        return "NA"
    }
}



export function getDateRangeBetweenDates(startDate, endDate) {

      const date = new Date(new Date(startDate).getTime());
      const dates = [];

      while (date <= new Date(endDate)) {
        dates.push(getDateFormatForUTC(new Date(date)));
        date.setDate(date.getDate() + 1);
      }
      return dates;
}

export function isItCurrentAttendanceCyle(startDate) {

    // if(new Date().getDate()>=1 && new Date().getDate()<=21){

    //         return new Date(startDate+" 00:00")>=new Date(new Date().getFullYear()+"-"+(new Date().getMonth())+"-21 00:00");
    // }else{
    //      return new Date(startDate+" 00:00")>=new Date(new Date().getFullYear()+"-"+(new Date().getMonth()+1)+"-21 00:00");
    // }

     if(new Date().getDate()>=1 && new Date().getDate()<=21){

                               return new Date(startDate+" 00:00")>=new Date((new Date().getMonth()===0 ? (new Date().getFullYear()-1)+"-12" : new Date().getFullYear()+"-"+new Date().getMonth())+"-21 00:00");
                        }else{
                             return new Date(startDate+" 00:00")>=new Date((new Date().getMonth()===0 ? (new Date().getFullYear()+1)+"-01" : new Date().getFullYear()+"-"+new Date().getMonth()+1)+"-21 00:00");
                        }
}

export function isItValidForMarkingAttendance(startDate) {

   

    if(new Date().getDate()>=1 && new Date().getDate()<=21){
         return new Date(startDate+" 00:00")<=new Date(new Date().getFullYear()+"-"+(new Date().getMonth()+1)+"-20 00:00") && new Date(startDate+" 00:00")>=new Date(new Date().getMonth()===0 ? new Date().getFullYear()-1+"-12-21 00:00" : new Date().getFullYear()+"-"+(new Date().getMonth())+"-21 00:00");

    }else{
         return new Date(startDate+" 00:00")<=new Date(new Date().getMonth()===11 ? new Date().getFullYear()+1+"-1-20 00:00" : new Date().getFullYear()+"-"+(new Date().getMonth()+2)+"-20 00:00") && new Date(startDate+" 00:00")>=new Date(new Date().getFullYear()+"-"+(new Date().getMonth()+1)+"-21 00:00");
    }
}

export function getCurrentAttendanceCyle(){
    if(new Date().getDate()>=1 && new Date().getDate()<=21){

    }else{

    }
}






export function getDateFormatForUTC(UTCdata) {
    // console.log("Time", UTCdata)
    if (UTCdata) {
        let newDate = String(new Date(UTCdata))
        let array = []
        array = newDate.split(" ")
        // console.log(array[2] + "-" + getMonth(array[1]) + "-" + array[3])
        return array[3] + "-" + getMonth(array[1]) + "-" + array[2]
    } else {
        return ""
    }
}

export function getDateTimeFormatForUTC(UTCdata) {
    // console.log("Time", UTCdata)
    if (UTCdata) {
        let newDate = String(new Date(UTCdata))
        let array = []
        array = newDate.split(" ")
        return array[3] + "-" + getMonth(array[1]) + "-" + array[2] + " " + array[4]
    } else {
        return ""
    }
}

export function getDisplayDateFormateForUser(date) {
    if (date && date !== "NA") {
        let array = date.split("-")
        if (array && array.length > 0) {
            return array[2] + "-" + getMonthString(array[1] + "") + "-" + array[0]
        } else {
            return "NA"
        }
    }
}


export function getDisplayDateFormateMonthDate(date) {
    if (date && date !== "NA") {
        let array = date.split("-")
        if (array && array.length > 0) {
            return getMonthString(array[1] + "")+" - "+array[2]
        } else {
            return "NA"
        }
    }
}


export function getDateFromQuerytime(UTCdata) {
    if (UTCdata) {
        UTCdata = UTCdata + ""
        let date = UTCdata.split(" ")
        let array = date[0].split("-")
        // console.log(array[2] + "-" + array[1] + "-" + array[0])
        return array[0] + "-" + array[1] + "-" + array[2]
    } else {
        return ""
    }
}

export function getMonth(monthInString) {
    switch (monthInString) {
        case 'Jan':
            return "01"

        case 'Feb':
            return "02"

        case 'Mar':
            return "03"

        case 'Apr':
            return "04"

        case 'May':
            return "05"

        case 'Jun':
            return "06"

        case 'Jul':
            return "07"

        case 'Aug':
            return "08"

        case 'Sep':
            return "09"

        case 'Oct':
            return "10"

        case 'Nov':
            return "11"

        case 'Dec':
            return "12"

        default:
            return "00"
    }
}

export function getMonthString(month) {
    switch (month) {
        case '01':
            return "Jan"

        case '1':
            return "Jan"

        case '02':
            return "Feb"

        case '2':
            return "Feb"

        case '03':
            return "Mar"

        case '3':
            return "Mar"

        case '04':
            return "Apr"

        case '4':
            return "Apr"

        case '05':
            return "May"

        case '5':
            return "May"

        case '06':
            return "Jun"

        case '6':
            return "Jun"

        case '07':
            return "Jul"

        case '7':
            return "Jul"

        case '08':
            return "Aug"

        case '8':
            return "Aug"

        case '09':
            return "Sep"

        case '9':
            return "Sep"

        case '10':
            return "Oct"

        case '11':
            return "Nov"

        case '12':
            return "Dec"

        default:
            return "NA"
    }
}
export function printKotImage(kotFile){
    let pageLink = "about:blank";
    let pwa = window.open(pageLink, "_new");
    pwa.document.open();
    pwa.document.write(ImageToPrint(kotFile));
    pwa.document.close();
}
function ImageToPrint(source) {
    return "<html><head><script>function step1(){\n" +
            "setTimeout('step2()', 10);}\n" +
            "function step2(){"+
            "WebBrowser1.ExecWB(6, 6)"+
                "window.print();window.close()}\n" +
            "</script></head><body onload='step1()'>\n" +
            " <object ID='WebBrowser1' WIDTH='0' HEIGHT='0'CLASSID='CLSID:8856F961-340A-11D0-A96B-00C04FD705A2'>  </object>" +
            "<img src='" + source + "' /></body></html>";
}




export function checkPrivileges(url,userProps) {

    if(userProps && userProps.privileges) {
            let userPrivileges=[]
            let privilegesObj = userProps.privileges
            let pri=Object.entries(privilegesObj);

            pri.map(function(item) { 
                userPrivileges.push({"name":item[1].name,"api_access":item[1].api_access,"app_access":item[1].app_access}) 
                return true
            })

                let flagCheck=false;
                userPrivileges.map(function(item) {
                    if(item.app_access===url){
                        flagCheck=true;
                        }
                        return true
                });

                return flagCheck       

        }else{
            return true

        }     

}



// function mapStateToProps(state) {
//     return {
//         user: state.user,
//     }
// }

export default connect(updateBuildNumber)(withRouter(helpers))


// WEBPACK FOOTER //
// ./src/common/helpers.js